<template>
    <div>
        <div class="card__delete">
            <slot name="card_content">
            </slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "card-delete"
}
</script>

<style scoped>
.card__delete {
    width: 100%;
    height: 100%;

    background: #FFFFFF;
    box-shadow: 0 3px 4px rgba(30, 18, 13, 0.1);
    border-radius: 6px;
}
</style>



// WEBPACK FOOTER //
// resources/office/js/components/dashboard-v5/delete-account/components/card-delete.vue